// Horizontal card rail — prev/next arrows scroll an overflowing card row.
// Progressive enhancement: the rail scrolls fine on its own; the arrows are
// hidden until JS wires them up and are removed from the tab order / hidden
// entirely when there is nothing to scroll. Drives every [data-rail] instance
// (service-tiers packages, cases + news highlights, …).

function step(track) {
  // One card + gap, derived from the first item so it stays in sync with the
  // auto-cols width instead of a hardcoded number.
  const item = track.querySelector('[data-rail-item]');
  if (!item) return track.clientWidth * 0.9;
  const gap = parseFloat(getComputedStyle(item.parentElement).columnGap) || 16;
  return item.offsetWidth + gap;
}

function sync(root, track) {
  const prev = root.querySelector('[data-rail-prev]');
  const next = root.querySelector('[data-rail-next]');
  const max = track.scrollWidth - track.clientWidth;
  const scrollable = max > 1;
  // Hide the whole control cluster when everything already fits.
  const nav = root.querySelector('[data-rail-nav]');
  if (nav) nav.hidden = !scrollable;
  if (prev) prev.disabled = track.scrollLeft <= 1;
  if (next) next.disabled = track.scrollLeft >= max - 1;
}

function init(root) {
  const track = root.querySelector('[data-rail-track]');
  if (!track || root.dataset.railReady) return;
  root.dataset.railReady = '1';

  root.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-rail-prev],[data-rail-next]');
    if (!btn || !root.contains(btn)) return;
    const dir = btn.hasAttribute('data-rail-next') ? 1 : -1;
    track.scrollBy({ left: dir * step(track), behavior: 'smooth' });
  });

  track.addEventListener('scroll', () => sync(root, track), { passive: true });
  window.addEventListener('resize', () => sync(root, track));
  sync(root, track);
}

function boot() {
  document.querySelectorAll('[data-rail]').forEach(init);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot);
} else {
  boot();
}
